import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import './UserGuide.css';

// --- Assets ---
// Overview Card
import ovImg1 from '../assets/guide/images/overview Tab/Overview Card/Image_1.webp';
import ovImg2 from '../assets/guide/images/overview Tab/Overview Card/Image_2.webp';

// Reports Card
import repImg1 from '../assets/guide/images/overview Tab/reports Card/rep_1.webp';
import repImg2 from '../assets/guide/images/overview Tab/reports Card/rep_2.webp';
import repImg3 from '../assets/guide/images/overview Tab/reports Card/rep_3.webp';
import repImg4 from '../assets/guide/images/overview Tab/reports Card/rep_4.webp';
import repImg5 from '../assets/guide/images/overview Tab/reports Card/rep_5.webp';
import repImg6 from '../assets/guide/images/overview Tab/reports Card/rep_6.webp';
import repImg7 from '../assets/guide/images/overview Tab/reports Card/rep_7.webp';

// Correspondence
import corrVid1 from '../assets/guide/videos/correspondence Tab/1_Creating_Correspondance.mp4';
import corrVid2 from '../assets/guide/videos/correspondence Tab/2_applying_filters.mp4';
import corrVid3AppendEntry from '../assets/guide/videos/correspondence Tab/3_Appending Entry.mp4';
import corrImg31CorrespondenceReport from '../assets/guide/videos/correspondence Tab/3.1_Correspondence Report.png';
import corrImg32ThreadReportPreview from '../assets/guide/videos/correspondence Tab/3.2_Correspondence Thread Report Preview.png';

// Financials
import finVid1 from '../assets/guide/videos/Financials/BG  Insurance Bonds.mp4';
import finVid2 from '../assets/guide/videos/Financials/MilestoneEOT Requests.mp4';
import finVid3 from '../assets/guide/videos/Financials/RA Bills Register.mp4';

// Technical & Execution
import exVid1 from '../assets/guide/videos/Technical  & Execution/Drawings&Design.mp4';
import exVid2 from '../assets/guide/videos/Technical  & Execution/Deviatins&Extra_Items.mp4';
import exVid3 from '../assets/guide/videos/Technical  & Execution/Specialized_Items.mp4';
import exVid4 from '../assets/guide/videos/Technical  & Execution/QAQC.mp4';
import exVid5 from '../assets/guide/videos/Technical  & Execution/Clearance.mp4';

// Agreement & Scope
import asImg1 from '../assets/guide/images/Agreement&Scope/Project Scope.webp';
import asImg2 from '../assets/guide/images/Agreement&Scope/Project Scope Detail.webp';
import asVid1 from '../assets/guide/videos/Agreement&Scope/Project Hand Over.mp4';
import asVid2 from '../assets/guide/videos/Agreement&Scope/Site_Office.mp4';
import asVid3 from '../assets/guide/videos/Agreement&Scope/Client_Office.mp4';

// Admin Panel
import adVid1 from '../assets/guide/videos/Admin Panel/Projects_List.mp4';
import adVid2 from '../assets/guide/videos/Admin Panel/Users&Roles.mp4';
import adVid3 from '../assets/guide/videos/Admin Panel/Consultants.mp4';
import adVid4 from '../assets/guide/videos/Admin Panel/Project_Assignments.mp4';

const Icons = {
  Overview: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>
  ),
  Mail: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1-.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
  ),
  Finance: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
  ),
  Execution: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
  ),
  Scope: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
  ),
  Admin: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
  ),
  Play: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
  ),
  Pause: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>
  ),
  Expand: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
  ),
  ArrowLeft: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
  ),
  ChevronRight: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
  ),
  Search: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
  )
};

function stripUiHighlightMarkers(s) {
  return String(s || '').replace(/\*([^*]+)\*/g, '$1');
}

/** Lowercase, strip UI markers, keep letters/digits as word tokens. */
function normalizeGuideSearchText(s) {
  return stripUiHighlightMarkers(String(s || ''))
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Max edit distance allowed for fuzzy word match (typos). */
function maxEditDistForLength(len) {
  if (len <= 3) return 1;
  if (len <= 6) return 2;
  if (len <= 10) return 3;
  return Math.min(4, Math.floor(len * 0.35));
}

function levenshtein(a, b) {
  const m = a.length;
  const n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  const row = new Array(n + 1);
  for (let j = 0; j <= n; j += 1) row[j] = j;
  for (let i = 1; i <= m; i += 1) {
    let prev = row[0];
    row[0] = i;
    for (let j = 1; j <= n; j += 1) {
      const tmp = row[j];
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + cost);
      prev = tmp;
    }
  }
  return row[n];
}

/**
 * Extra tokens to try when the user types an abbreviation or related word
 * (any one match counts as satisfying that query token).
 */
const GUIDE_SEARCH_RELATED = {
  ra: ['running', 'account', 'bill', 'bills', 'certification', 'certified', 'payable', 'payment', 'gross', 'deduction'],
  bg: ['bank', 'guarantee', 'guarantees', 'insurance', 'bond', 'bonds', 'instrument', 'issuer', 'expiry', 'renewal'],
  eot: ['extension', 'milestone', 'milestones', 'shift', 'timeline', 'schedule', 'delay', 'baseline'],
  qa: ['qaqc', 'quality', 'inspection', 'checklist', 'inspector', 'pass', 'fail', 'conditional'],
  qc: ['qaqc', 'quality', 'inspection', 'checklist'],
  qaqc: ['quality', 'inspection', 'checklist', 'qa', 'qc'],
  noc: ['clearance', 'clearances', 'approval', 'fire', 'environment', 'statutory', 'authority'],
  corr: ['correspondence', 'correspond', 'letter', 'letters', 'communication', 'thread', 'register', 'subject', 'inward', 'outward', 'reply', 'sla'],
  cores: ['correspondence', 'correspond'],
  dev: ['deviation', 'deviations', 'extra', 'boq', 'variance', 'item', 'items'],
  spec: ['specialized', 'special', 'procurement', 'vendor', 'fat', 'delivery', 'datasheet'],
  assign: ['assignment', 'assignments', 'employee', 'consultant', 'consultants', 'project', 'link'],
  hand: ['handover', 'received', 'recipient', 'transfer', 'deliverable'],
  draw: ['drawing', 'drawings', 'design', 'revision', 'discipline', 'approval', 'shop', 'submitted'],
  site: ['office', 'field', 'location', 'setup', 'map'],
  client: ['office', 'stakeholder', 'visit', 'department', 'official'],
  fin: ['financial', 'finance', 'compliance', 'mandays', 'value', 'agreement'],
  report: ['reports', 'summary', 'kpi', 'export', 'pdf', 'download', 'chart', 'filter'],
  over: ['overdue', 'targeted', 'reply', 'due', 'pending', 'open', 'closed'],
  dash: ['overview', 'dashboard', 'portfolio', 'health', 'snapshot'],
  admin: ['administrator', 'user', 'users', 'roles', 'login', 'password', 'permission'],
  mile: ['milestone', 'milestones', 'eot', 'shift', 'tracker'],
  clear: ['clearance', 'authority', 'submission', 'target', 'permit'],
  scope: ['agreement', 'project', 'card', 'value', 'timeline', 'compliance'],
  user: ['users', 'roles', 'email', 'mobile', 'credential'],
  consult: ['consultant', 'consultants', 'discipline', 'firm'],
  proj: ['project', 'projects', 'prefix', 'loa', 'award', 'master'],
  attach: ['attachment', 'attachments', 'upload', 'file', 'pdf', 'document'],
  pay: ['payment', 'paid', 'unpaid', 'balance', 'net', 'deduction'],
  cert: ['certification', 'certified', 'approved', 'clearance'],
};

function expandGuideSearchToken(token) {
  const t = token.toLowerCase();
  const out = new Set([t]);
  const related = GUIDE_SEARCH_RELATED[t];
  if (related) related.forEach((w) => out.add(w));
  return [...out];
}

function fuzzyVariantMatchesHay(variant, hayNorm, hayWords) {
  const v = variant;
  if (!v) return false;

  if (hayNorm.includes(v)) return true;

  const maxDist = maxEditDistForLength(v.length);
  for (let i = 0; i < hayWords.length; i += 1) {
    const w = hayWords[i];
    if (!w) continue;
    if (w === v) return true;
    if (Math.abs(w.length - v.length) > maxDist) continue;
    if (levenshtein(v, w) <= maxDist) return true;
    if (v.length >= 4 && w.length >= 4) {
      if (w.includes(v) || v.includes(w)) return true;
    }
  }
  return false;
}

function sectionMatchesGuideSearch(section, queryNormalized) {
  if (!queryNormalized) return true;

  const parts = [section.title, section.subtitle, section.label, section.description, section.detailDescription].filter(Boolean);
  const hayNorm = normalizeGuideSearchText(parts.join(' '));
  if (!hayNorm) return false;

  const tokens = queryNormalized.split(' ').filter((t) => t.length >= 2);
  if (tokens.length === 0) return false;

  const hayWords = hayNorm.split(' ').filter(Boolean);

  for (let ti = 0; ti < tokens.length; ti += 1) {
    const token = tokens[ti];
    const variants = expandGuideSearchToken(token);
    const anyHit = variants.some((variant) => fuzzyVariantMatchesHay(variant, hayNorm, hayWords));
    if (!anyHit) return false;
  }

  return true;
}

/** Renders *Screen or Button Name* in guide copy as emphasized UI labels. */
function parseUiHighlights(text) {
  if (text == null || typeof text !== 'string') return text;
  const parts = text.split(/(\*[^*]+\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={i} className="v-doc-ui-highlight">{part.slice(1, -1)}</em>;
    }
    return part;
  });
}

const ScrollSpyNav = React.memo(({ sections }) => {
  const [activeId, setActiveId] = useState(sections[0]?.id || '');
  useEffect(() => {
    if (sections.length > 0) setActiveId(sections[0].id);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) setActiveId(entry.target.id);
      });
    }, { threshold: [0.1, 0.2, 0.5, 0.8], rootMargin: '-10% 0px -45% 0px' });
    sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [sections]);
  const scrollTo = (id) => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
  return (
    <div className="v-spy-fixed-container">
      {sections.map(section => (
        <div key={section.id} className="v-spy-item group" onClick={() => scrollTo(section.id)}>
          <span className="v-spy-label">{section.label || section.title || section.subtitle}</span>
          <div className={`v-spy-dot ${activeId === section.id ? 'active' : ''}`}></div>
        </div>
      ))}
    </div>
  );
});

const VisualMedia = React.memo(({ mediaType, mediaSrc, mediaSlides = [], onExpand, isModal, onClose, initialTime = 0, isRowVisible }) => {
  const videoRef = useRef(null);
  const progressBarRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const isVideo = mediaType === 'video';
  const currentImageSrc = mediaSrc || (Array.isArray(mediaSlides) && mediaSlides.length ? mediaSlides[0] : '');
  useEffect(() => { if (isVideo && initialTime > 0 && videoRef.current) videoRef.current.currentTime = initialTime; }, [initialTime, isVideo]);
  useEffect(() => {
    if (!isVideo || isModal || !videoRef.current) return;
    if (isRowVisible) { videoRef.current.play().catch(() => {}); setIsPlaying(true); } 
    else { videoRef.current.pause(); setIsPlaying(false); }
  }, [isRowVisible, isModal, isVideo]);
  const togglePlay = (e) => {
    if (!isVideo) return;
    if (e) e.stopPropagation();
    if (videoRef.current.paused) { videoRef.current.play(); setIsPlaying(true); } 
    else { videoRef.current.pause(); setIsPlaying(false); }
  };
  const handleSeek = (e) => {
    if (!isVideo || !videoRef.current || !progressBarRef.current || !videoRef.current.duration) return;
    e.stopPropagation();
    const rect = progressBarRef.current.getBoundingClientRect();
    const x = Math.min(Math.max(e.clientX - rect.left, 0), rect.width);
    const ratio = x / rect.width;
    videoRef.current.currentTime = ratio * videoRef.current.duration;
    setProgress(ratio * 100);
  };
  return (
    <div className={`v-doc-visual-container group ${isModal ? 'is-modal' : ''}`} onClick={togglePlay}>
      {isVideo ? (
        (isRowVisible || isModal) ? (
          <video ref={videoRef} src={mediaSrc} muted loop playsInline onTimeUpdate={() => setProgress((videoRef.current.currentTime / videoRef.current.duration) * 100)} className="v-doc-video-element" />
        ) : ( <div className="v-doc-video-placeholder" /> )
      ) : (
        <img src={currentImageSrc} alt="Visual" className="v-doc-video-element" style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
      )}
      <div className="v-doc-player-overlay">
        {isModal && <button className="v-doc-modal-close-btn shadow-v-icon" onClick={onClose}><Icons.Close /></button>}
        {isVideo && <button onClick={togglePlay} className="v-doc-play-pause-btn shadow-v-icon">{isPlaying ? <Icons.Pause /> : <Icons.Play />}</button>}
        {!isModal && onExpand && ( <button onClick={(e) => { e.stopPropagation(); onExpand(mediaType, currentImageSrc, isVideo ? (videoRef.current?.currentTime || 0) : 0); }} className="v-doc-expand-btn shadow-v-icon"><Icons.Expand /></button> )}
        {isVideo && (
          <div className="v-doc-bottom-progress-container" onClick={handleSeek}>
            <div ref={progressBarRef} className="v-doc-progress-bg">
              <div className="v-doc-progress-fill" style={{ width: `${progress}%` }}>
                <div className="v-doc-progress-knob"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

const SectionRow = React.memo(({ section, index, handleExpand, onDetail, isDetailRow = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const rowRef = useRef();
  useEffect(() => {
    const node = rowRef.current;
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.unobserve(entry.target); } }, { threshold: 0.15 });
    if (node) observer.observe(node);
    return () => node && observer.unobserve(node);
  }, []);
  const isTextLeft = index % 2 !== 0;
  const appendOverviewMockup = !isDetailRow && section.id === 'co-1b';
  const detailAppendHeroVideo = isDetailRow && (section.id === 'co-1b-g1' || section.id === 'fi-1-g1');
  return (
    <div
      id={section.id}
      ref={rowRef}
      className={`v-doc-row ${isVisible ? 'reveal-active' : 'reveal-hidden'} ${isTextLeft ? 'text-left' : 'text-right'}${detailAppendHeroVideo ? ' v-doc-row--detail-hero-video' : ''}`}
    >
      <div
        className={`v-doc-visual-block${appendOverviewMockup ? ' v-doc-visual-block--append-mockup' : ''}${detailAppendHeroVideo ? ' v-doc-guided-video' : ''}`}
      >
        <VisualMedia mediaType={section.type || section.mediaType} mediaSrc={section.src || section.mediaSrc} mediaSlides={section.slides || section.mediaSlides || section.gallery?.map((g) => g.src).filter(Boolean)} onExpand={handleExpand} isRowVisible={isVisible} />
      </div>
      <div className="v-doc-text-block">
        <h3 className="v-doc-section-title">{section.subtitle || section.title}</h3>
        <p className="v-doc-section-desc">{parseUiHighlights(section.text || section.description)}</p>
        {!isDetailRow && onDetail && <button className="v-doc-view-more-btn" onClick={() => onDetail(section)}>View More Details</button>}
      </div>
    </div>
  );
});

const StepFlowGuide = React.memo(({ title = "Step-by-Step Guide", steps = [] }) => {
  const [activeStep, setActiveStep] = useState(0);
  if (!steps.length) return null;
  return (
    <div className="v-doc-step-flow">
      <h3 className="v-doc-step-title">{title}</h3>
      <div className="v-doc-step-list">
        {steps.map((step, idx) => (
          <div
            key={`step-${idx}`}
            className={`v-doc-step-item ${activeStep === idx ? 'is-active' : ''}`}
            onMouseEnter={() => setActiveStep(idx)}
          >
            <div className="v-doc-step-dot">{idx + 1}</div>
              <p className="v-doc-step-text">
              {step.includes(':') ? (
                <>
                  <strong className="v-doc-step-field">{parseUiHighlights(`${step.split(':')[0]}:`)}</strong>
                  <span className="v-doc-step-body">{parseUiHighlights(step.slice(step.indexOf(':') + 1).trim())}</span>
                </>
              ) : (
                parseUiHighlights(step)
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
});

const UserGuide = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [expanded, setExpanded] = useState(null);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [guideSearchQuery, setGuideSearchQuery] = useState('');

  const handleExpand = (type, src, time) => setExpanded({ type, src, time });
  const closeExpanded = useCallback(() => setExpanded(null), []);

  useEffect(() => {
    if (selectedDetail) {
      window.scrollTo(0, 0);
    }
  }, [selectedDetail]);

  useEffect(() => {
    const handleEsc = (e) => e.key === 'Escape' && closeExpanded();
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [closeExpanded]);

  const GUIDE_DATA = useMemo(() => ({
    overview: {
      icon: <Icons.Overview />,
      label: "Overview",
      sections: [
        { 
          id: 'ov-1', title: "Overview", label: "Overview", 
          description: "This image shows the *Overview* dashboard with top project and correspondence KPIs, followed by key Financial KPI cards for daily monitoring.",
          detailDescription: "The *Overview* page is a quick health snapshot of the application. The upper KPI band shows project count, portfolio value, correspondence volume, and reply-due pressure. The Financial KPI area highlights pending certification, pending payment, upcoming BG expiry, and EOT or milestone shift load so teams can prioritize action quickly.",
          flowTitle: "Overview Field Guide",
          flowSteps: [
            "*All Projects*: Shows total project count with active/closed split.",
            "*Total Projects Value*: Shows the combined agreement value of selected scope.",
            "*Correspondence*: Shows total communication count with inward/outward split.",
            "*Reply Dues*: Shows open items that crossed reply due date.",
            "*RA Pending Certification*: Shows RA bills waiting certification stage.",
            "*RA Pending Payment*: Shows certified or part-paid amount still unpaid.",
            "*BG Expiring*: Shows instruments nearing expiry within alert window.",
            "*EOT / Milestone Shift Pending*: Shows timeline-shift requests awaiting approval."
          ],
          mediaType: 'image', mediaSrc: ovImg1,
          gallery: [
            { id: 'ov-1-g1', subtitle: "KPI Summary", text: "The top strip presents portfolio-level KPIs (*All Projects*, *Total Projects Value*, *Correspondence*, and *Reply Dues*) and helps you judge overall status in one view.", type: 'image', src: ovImg1 },
            { id: 'ov-1-g2', subtitle: "Active Projects", text: "Project cards show agreement value, start date, stipulated completion date, and progress percentage so low-progress or delayed projects can be identified quickly.", type: 'image', src: ovImg2 }
          ],
          details: [
            { subtitle: "How to read this page", text: "Review the top KPIs first, then confirm financial pending indicators, and move to the relevant module for action-level updates." },
            { subtitle: "Why it is important", text: "This page reduces time spent checking multiple modules and gives a clear first view of communication and finance risk." },
            { subtitle: "Expected result", text: "Teams can quickly decide what needs immediate follow-up and what can be monitored in routine cycles." }
          ]
        },
        { 
          id: 'ov-2', title: "Reports", label: "Reports", 
          description: "This tab consolidates *Summary*, *Correspondence*, *Financials & BG*, *Technical & Clearance*, and *Drawings & Design* reports with filter and *Download PDF* export support.", 
          detailDescription: "The *Reports* page gives consolidated monitoring and export-ready summaries. Select the project scope first, then review each report tab to validate communication risk, financial exposure, technical blockers, and drawing approvals before sharing the final PDF with *Download PDF*.",
          mediaSlides: [repImg1, repImg2, repImg3, repImg4, repImg5, repImg6, repImg7],
          mediaType: 'image', mediaSrc: repImg1,
          gallery: [
            { id: 'ov-2-g1', subtitle: "Summary Report", text: "This screen shows the *Project* filter, *Download PDF* button, and the *Summary* tab with Critical KPI cards: *Open Correspondence*, *Targeted Reply Overdue*, *RA Pending Certification*, *BG Expiring (30 days)*, *RA Pending Payment*, *EOT/Shift Pending*, *Clearance Overdue*, and *QAQC Fail/Conditional*.", type: 'image', src: repImg1 },
            { id: 'ov-2-g3', subtitle: "Correspondence Report", text: "This screen shows *Overdue Correspondence (Top 10)*, *Main Categories* chart with Total vs Open thread bars, and *Correspondence Register* export controls including *Status*, *Priority*, *Category*, last letter date range, and subject search.", type: 'image', src: repImg3 },
            { id: 'ov-2-g4', subtitle: "RA Bills Report", text: "This table shows RA bill-wise financial tracking with *RA Ref*, *Status*, *Payment Status*, *Net Payable*, and *Balance* columns. It helps identify paid vs part-paid bills and outstanding balance per RA entry.", type: 'image', src: repImg4 },
            { id: 'ov-2-g5', subtitle: "BG Risk View", text: "This screen combines four risk sections: *Outstanding by Project*, *Upcoming BG Renewals (DTE <= 60)*, *BG Status Distribution*, and *Cross-Module Risk Snapshots* (for example certified RA unpaid beyond due date and BG expiry with pending EOT).", type: 'image', src: repImg5 },
            { id: 'ov-2-g6', subtitle: "Technical & Clearance Report", text: "This view shows *Pending Clearances* table (*Clearance Ref*, *Type*, *Authority*, *Target Date*, *Status*) and *Technical Quality Snapshot* cards for *Pending Deviations*, *Total Variance Value*, *QAQC Fail/Conditional*, and *Pending Clearances*.", type: 'image', src: repImg6 },
            { id: 'ov-2-g7', subtitle: "Drawings & Design Report", text: "This screen shows drawing KPI cards (*Drawing Register Total*, *Pending Approval*, *Overdue Response*, *Site Hold*), plus two operational tables: *Drawing Register* and *Pending Approval* with required-by timeline visibility.", type: 'image', src: repImg7 }
          ],
          details: [
            { subtitle: "Project filtering", text: "Use a single project for focused review or *All Projects* for portfolio-level analysis, then validate cards and tables in the selected scope." },
            { subtitle: "Recommended flow", text: "Review *Summary* first, then *Correspondence*, *Financials & BG*, *Technical & Clearance*, and *Drawings & Design* to maintain complete coverage." },
            { subtitle: "Export behavior", text: "*Download PDF* captures the active report tab and applied filters, so confirm filters before downloading." }
          ]
        },
        
      ]
    },
    correspondence: {
      icon: <Icons.Mail />, label: "Correspondence",
      sections: [
        { 
          id: 'co-1', title: "Correspondence Register", label: "Register", 
          description: "Client Correspondence is the complete official communication record between your team and all project stakeholders. This register keeps each subject in one thread with dates, priority, status, attachments, and follow-up history so communication remains traceable, accountable, and easy to audit.",
          detailDescription: "To create a new correspondence, open *Correspondence Register* and click *New Correspondence Subject*. Fill the form with correct project context, subject details, communication metadata, and supporting documents, then click *Create Correspondence Subject* to create a traceable thread for all future updates and follow-ups.",
          flowTitle: "Field-by-Field Guide (What to Fill)",
          flowSteps: [
            "Project: Select the correct project where this communication belongs. Always verify project name before filling other fields.",
            "Subject: Enter a short and specific title that clearly identifies the issue/request (avoid generic names like \"Update\" or \"Letter\").",
            "Category: Choose the topic type correctly. Use *General* for normal communication, *RA Bill* for billing issues, *BG/Insurance* for instruments, *Clearance* for approvals, *Milestone/EOT* for schedule extension, and *Drawing* for design-related communication.",
            "Priority: Choose *Critical* for immediate escalation, *Urgent* for high-priority same-cycle action, *Routine* for normal follow-up, and *Low* when no immediate risk is present.",
            "Direction (*Inward*/*Outward*): Select *Inward* when your team received the communication; select *Outward* when your team sent the communication.",
            "Letter Reference Number: Enter the exact document reference number from the source letter/email for traceability.",
            "Letter Date: Fill the original communication date exactly as mentioned in the source document.",
            "From / To: Enter sender and receiver names/organizations exactly as in the communication record.",
            "Mode: Choose *Email* when sent by email thread, *Letter* for signed physical/official letter, and use other mode only when the record came by that channel.",
            "Summary: Write what is requested, why it is raised, and what action/response is expected in plain language.",
            "Attachments: Upload all required supporting files (signed letter, note sheet, drawing extract, bill sheet, etc.) with meaningful file names.",
            "Response Expected / SLA: Enable when a reply is mandatory. Set realistic SLA days so *Open/Targeted Reply Overdue* tracking is meaningful.",
            "Status Decision: Keep thread *Open* while action is pending; move to *Closed* only after issue is fully resolved with proof in thread."
          ],
          mediaType: 'video', mediaSrc: corrVid1,
          details: [
            { id: 'co-1-d1', subtitle: "How to use", text: "This is the master page for all correspondence. Use it when you need complete history and full control of filters." }
          ]
        },
        {
          id: 'co-1b',
          title: "Append Correspondence",
          label: "Append Entry",
          description: "Use *Append Entry* to add the next letter or email in the same subject. This keeps all updates in one timeline with the right references and attachments.",
          detailDescription: "Use this section when a subject already exists and you want to add the next communication in the same thread. First, watch the video to see where to click and how the flow works. Next, follow the *Field-by-Field Guide* and enter each value exactly from the letter or email (date, reference, sender, receiver, mode, priority, summary, and attachments). Then save with *Append Entry*. Finally, use the two report previews: *Correspondence report* for overall project tracking, and *thread report* for one subject's full communication history.",
          flowTitle: "Field-by-Field Guide (Append Entry)",
          flowSteps: [
            "Direction: Choose *Inward* if you received the communication, or *Outward* if you sent it.",
            "Letter/Email Date: Enter the date shown on the letter or email.",
            "Letter Reference No: Enter the exact reference number from the document.",
            "From / To: Enter sender and receiver exactly as written. Use *To* dropdown, or choose *Other* and type manually.",
            "Mode: Choose how the communication was sent or received (for example, *Email* or *Letter*).",
            "Priority: Select *Critical*, *Urgent*, *Routine*, or *Low*.",
            "Targeted Reply (Days): If a reply is needed, enter the number of days allowed.",
            "Summary: Briefly write what happened and what action is needed.",
            "Attachments: Upload the signed letter, email PDF, drawings, or exhibits referenced in this entry—attachments are usually mandatory for official records.",
            "Response Expected: Keep this checked if you still need a reply.",
            "Save: Click *Append Entry* to save. Click *Cancel* to exit without saving."
          ],
          mediaType: 'video',
          mediaSrc: corrVid3AppendEntry,
          gallery: [
            {
              id: 'co-1b-g1',
              subtitle: "Video: Appending an entry",
              text: "Start here. The clip shows the real flow: open the subject, stay on *Timeline*, click *+ Append Entry*, walk through the modal, and save—so you see motion, focus states, and where each control sits before you read the static field map below.",
              type: 'video',
              src: corrVid3AppendEntry
            },
            {
              id: 'co-1b-g2',
              subtitle: "Correspondence report (portfolio view)",
              text: "This is the *Reports → Correspondence* slice: portfolio- or project-level KPIs, overdue lists, category charts, and export-style filters. Use it when leadership wants breadth—how many threads are open, where delays cluster—not the letter-by-letter story of one subject.",
              type: 'image',
              src: corrImg31CorrespondenceReport
            },
            {
              id: 'co-1b-g3',
              subtitle: "Correspondence thread report (preview)",
              text: "This preview is the opposite scale: one subject only. *View Report* on the thread lays out the full chain—each appended entry in order, references, priority, and attachment links—in a print-ready layout. Use it to verify the narrative before you circulate PDFs internally or to the client.",
              type: 'image',
              src: corrImg32ThreadReportPreview
            }
          ],
          details: [
            {
              id: 'co-1b-d1',
              subtitle: "Why append instead of new subject",
              text: "Keep one subject for one conversation. Appending entries keeps the full history in one place and avoids confusion."
            }
          ]
        },
        { 
          id: 'co-2', title: "Open / Targeted Reply Overdue", label: "Overdue", 
          description: "This tab shows only open correspondence where reply commitment is pending or overdue. It is used to identify delayed responses quickly and drive immediate follow-up action.", 
          detailDescription: "*Open / Targeted Reply Overdue* is an action-focused monitoring view. It highlights threads where response timelines are at risk or already breached, so teams can prioritize the right subjects, respond faster, and reduce communication delays.",
          flowTitle: "Field Guide for Overdue Reply Control",
          flowSteps: [
            "View Scope: Shows only open threads with pending or overdue targeted replies.",
            "Project Filter: Select project to focus overdue workload for one team/location.",
            "Priority Filter: Use *Critical* first, then *Urgent*, then *Routine* to clear the highest-risk items first.",
            "Age Check: Review oldest pending items first to reduce long-delay backlog.",
            "Thread Action: Open subject, send response/update, and attach supporting proof.",
            "Reply Date Update: Enter latest reply details so overdue calculation is refreshed.",
            "Status Update: Keep *Open* if any pending response remains. Change to *Closed* only when complete closure is confirmed.",
            "Daily Review: Use this tab at least once daily to prevent SLA slippage."
          ],
          mediaType: 'video', mediaSrc: corrVid2,
          details: [
            { id: 'co-2-d1', subtitle: "Why this view matters", text: "Use this page daily to prevent communication delays and SLA misses." }
          ]
        }
      ]
    },
    financials: {
      icon: <Icons.Finance />, label: "Financials & Compliance",
      sections: [
        { 
          id: 'fi-1', title: "RA Bills Register", label: "RA Bills Register", 
          description: "Comprehensive register for RA billing with project filters, amount breakdown, payment status visibility, attachment management, and reporting support.", 
          detailDescription: "*RA Bills Register* is used to record, verify, and monitor Running Account bills project-wise. It captures billing amount, deductions, payment progression, and supporting documents so finance tracking remains clear from submission to final payment.",
          flowTitle: "Field-by-Field Guide (RA Bills Register)",
          flowSteps: [
            "Project: Select the correct project before creating or reviewing RA bill records.",
            "RA Reference / RA Number: Enter the exact RA bill identifier used in official billing documents.",
            "Billing Period: Fill period start and end dates for the work covered by this RA bill.",
            "Gross Work Done: Enter total certified gross value for the selected period.",
            "Deductions: Enter statutory, retention, recovery, or other approved deduction values.",
            "Net Payable: Verify net payable amount after deductions (gross minus deductions).",
            "Payment Status: Use *Unpaid* when not paid, *Part Paid* when partial payment released, *Paid* when fully settled, and *Certified* when approved but payment pending.",
            "Due / Payment Date: Enter due date and actual payment date for delay tracking.",
            "Remarks: Add concise notes for certification status, hold reason, or finance follow-up.",
            "Attachments: Upload supporting files such as RA sheet, certification note, and approval copy.",
            "Export / Print: Use *Download PDF* or print after applying final filters to share accurate billing status."
          ],
          mediaType: 'video', mediaSrc: finVid3,
          gallery: [
            {
              id: 'fi-1-g1',
              subtitle: "Video: RA Bills Register",
              text: "Watch this first. It shows how to open, review, and manage RA bills in the register.",
              type: 'video',
              src: finVid3
            },
            {
              id: 'fi-1-g2',
              subtitle: "RA Bills Register list",
              text: "This is the main RA Bills Register list. It shows bill rows, status, and actions. Sensitive numbers are blurred in this guide image.",
              type: 'video',
              src: finVid3,
            },
            {
              id: 'fi-1-g3',
              subtitle: "What opens on View",
              text: "When you click *View* on a row in the register list, this detailed RA bill preview opens. Sensitive values are blurred in this guide image.",
              type: 'video',
              src: finVid3,
            }
          ],
          details: [
            { id: 'fi-1-d1', subtitle: "Billing lifecycle", text: "Track each bill from submission to certification to final payment with clear financial visibility." }
          ]
        },
        { 
          id: 'fi-2', title: "BG / Insurance Bonds", label: "BG / Insurance Bonds", 
          description: "Central register for BG and insurance instruments with expiry visibility, compliance tracking, and renewal planning support.", 
          detailDescription: "*BG / Insurance Bonds* register tracks all financial instruments linked to project compliance. It helps teams monitor validity, renewal deadlines, bank/issuer details, and document readiness so no instrument expires without action.",
          flowTitle: "Field-by-Field Guide (BG / Insurance Bonds)",
          flowSteps: [
            "Project: Select the project where the BG or insurance instrument is applicable.",
            "Instrument Type: Choose *Bank Guarantee* for bank-issued guarantees; choose *Insurance Bond* for insurer-issued instruments.",
            "Purpose: Mention why this instrument is issued (performance/security/advance etc.).",
            "Instrument Number: Enter exact BG/Bond number as mentioned by issuing authority.",
            "Issuer / Bank / Branch: Fill issuing bank or insurer details for verification and follow-up.",
            "Amount: Enter sanctioned instrument amount exactly as per document.",
            "Issue Date: Record original issue date from the certificate.",
            "Validity / Expiry Date: Fill expiry date accurately for renewal alert tracking.",
            "Claim Expiry (if available): Enter claim period end date where required.",
            "Status: Use *Active* while valid, *Renewed* after extension, *Released* when no longer required, and *Expired* when lapsed.",
            "Attachments: Upload instrument copy, renewal letter, and approval/endorsement documents."
          ],
          mediaType: 'video', mediaSrc: finVid1,
          details: [
            { id: 'fi-2-d1', subtitle: "Expiry control", text: "This view helps avoid lapses by clearly showing upcoming expiries and renewal priorities." }
          ]
        },
        { 
          id: 'fi-3', title: "Milestone/EOT Requests", label: "Milestone/EOT Requests", 
          description: "Tracking page for project milestones and EOT requests, including schedule shift monitoring, approval follow-up, and status updates.", 
          detailDescription: "*Milestone/EOT Requests* page tracks planned timeline commitments and extension requests in one place. It supports schedule governance by recording baseline dates, revised dates, delay reasons, and approval movement until closure.",
          flowTitle: "Field-by-Field Guide (Milestone / EOT)",
          flowSteps: [
            "Project: Select the relevant project to view or create milestone/EOT records.",
            "Milestone Title: Enter a clear milestone name that matches contract scope.",
            "Baseline Date: Record the original contractual completion/target date.",
            "Revised / Requested Date: Enter proposed new date when shift or extension is requested.",
            "Delay Reason: Provide exact reason for shift (approval delay, scope change, external dependency etc.).",
            "Request Type: Choose *Milestone Shift* for date movement of a milestone; choose *EOT Request* for contractual time-extension request.",
            "Impact Details: Mention scope/time impact in brief for approval context.",
            "Approval Stage / Status: Use *Submitted* after filing, *Under Review* during evaluation, *Approved* after acceptance, *Rejected* if not accepted.",
            "Remarks: Add reviewer comments, decision notes, or pending action points.",
            "Attachments: Upload supporting letters, schedule sheets, and approval references.",
            "Final Update: Save status after each decision so report timelines remain current."
          ],
          mediaType: 'video', mediaSrc: finVid2,
          details: [
            { id: 'fi-3-d1', subtitle: "Schedule tracking", text: "Use this page to monitor baseline shifts and time-extension requests in one place." }
          ]
        }
      ]
    },
    execution: {
      icon: <Icons.Execution />, label: "Technical & Execution",
      sections: [
        {
          id: 'ex-1', title: "Drawings & Design", label: "Drawings & Design",
          description: "Tracks drawing registers, revision status, pending approvals, overdue responses, and discipline-wise design coordination.",
          detailDescription: "*Drawings & Design* helps engineering teams track drawing lifecycle from submission to approval. It improves review control by highlighting pending approvals, overdue responses, and stage-wise movement.",
          flowTitle: "Field-by-Field Guide (Drawings & Design)",
          flowSteps: [
            "Project: Select the project first. All drawing records are saved under this project.",
            "Discipline (dropdown): Choose *Architectural*, *Structural*, *MEP*, *Electrical*, *Plumbing*, *Fire Fighting*, *HVAC*, *ELV*, *Landscape*, *Interior*, *Infra/Roads*, or *Composite* based on the owner team.",
            "Drawing Type (dropdown): Choose *Concept* for early design, *Working* for execution issue, *Shop* for fabrication, *Coordination* for clash check, *As-Built* for final record.",
            "Drawing No: Enter exact drawing number from official issue sheet.",
            "Drawing Title: Enter full drawing name clearly.",
            "Sheet No: Enter when drawing has multiple sheets.",
            "Revision No: Enter current revision code (0, A, B...).",
            "Revision Date: Enter date of current revision release.",
            "Stage (dropdown): *Draft* before issue, *Submitted* after issue, *Under Review* while checking, *Approved* after acceptance, *Rejected*/*Resubmit* for corrections, *Superseded* when replaced.",
            "Submitted By / Submitted To / Received From: Fill sender, reviewer, and source details.",
            "Consultant Name / Vendor Name: Fill when consultant or vendor is involved.",
            "Submission Date / Required By Date / Approval Date: Fill all dates for approval and overdue tracking.",
            "Site Use Flag: Turn on when drawing is being used at site.",
            "Construction Hold Flag: Turn on when drawing issue is blocking work.",
            "Site Impact Level (dropdown): Use *None*/*Low*/*Medium*/*High*/*Blocking* based on field impact.",
            "Delay Risk Flag: Turn on if drawing delay may affect timeline.",
            "EOT Relevance Flag: Turn on if drawing issue may support EOT claim.",
            "Linked Milestone/EOT (dropdown): Link related *Milestone/EOT* record when applicable.",
            "Remarks and Change Summary: Add review notes and revision change summary.",
            "Attachments: Upload drawing files and supporting documents."
          ],
          mediaType: 'video', mediaSrc: exVid1
        },
        {
          id: 'ex-2', title: "Deviations & Extra Items", label: "Deviations & Extra Items",
          description: "Captures variation items, extra scope entries, and commercial impact for technical and billing alignment.",
          detailDescription: "Use *Deviations & Extra Items* to document approved and pending deviations from BOQ/scope. It ensures quantity, rate, and value changes are visible to engineering and finance teams.",
          flowTitle: "Field-by-Field Guide (Deviations & Extra Items)",
          flowSteps: [
            "Project: Select the project where the deviation or extra item is raised.",
            "Category (dropdown): Choose *Deviation* for changed approved scope, choose *Extra Item* for new work outside original BOQ.",
            "Title: Enter short clear title of the item.",
            "Description: Explain what changed and why.",
            "BOQ Item: Enter linked BOQ reference.",
            "Original Qty / Revised Qty: Enter before and after quantity values.",
            "Original Rate / Revised Rate: Enter before and after rates.",
            "Original Amount / Revised Amount: Calculated from quantity and rate values.",
            "Variance Amount / Variance %: System shows cost impact automatically.",
            "Status (dropdown): *Draft*, *Submitted*, *Under Review*, *Approved*, *Rejected* as per approval stage.",
            "Remarks: Add decision or review notes.",
            "Attachments: Upload calculations, sketches, approvals, and support files."
          ],
          mediaType: 'video', mediaSrc: exVid2
        },
        {
          id: 'ex-3', title: "Specialized Items", label: "Specialized Items",
          description: "Monitors long-lead or specialized procurement items with delivery, FAT, vendor, and status tracking.",
          detailDescription: "*Specialized Items* tracks long-lead procurement with tighter technical control. It helps avoid delays by monitoring lead time, FAT requirement, and expected delivery dates.",
          flowTitle: "Field-by-Field Guide (Specialized Items)",
          flowSteps: [
            "Project: Select the project where the specialized item is required.",
            "Item Name / Description: Enter exact item name used in procurement.",
            "Specification Ref: Enter specification reference code.",
            "Vendor Name / Country of Origin: Enter supplier and country details.",
            "Lead Time (days): Enter realistic lead time.",
            "Expected Delivery Date: Enter planned delivery date for due/overdue tracking.",
            "FAT Required (dropdown): *Yes* when pre-dispatch FAT is needed; *No* otherwise.",
            "Warranty Period (months): Enter warranty commitment if available.",
            "Special Instructions: Add handling/installation/inspection notes.",
            "Status (dropdown): *Draft*, *Submitted*, *Under Review*, *Approved*, *Rejected*, *Delivered*, *Closed* based on progress.",
            "Attachments: Upload datasheets, FAT reports, approvals, and related files."
          ],
          mediaType: 'video', mediaSrc: exVid3
        },
        {
          id: 'ex-4', title: "QAQC", label: "QAQC",
          description: "Maintains inspection and quality records with result tracking and action closure visibility.",
          detailDescription: "*QAQC* records quality inspections and outcomes. It supports compliance by tracking checklist results, pending actions, and closure evidence.",
          flowTitle: "Field-by-Field Guide (QAQC)",
          flowSteps: [
            "Project: Select project scope for quality record entry.",
            "Category and Activity: Select category and write activity name.",
            "Inspection Date and Inspector: Enter date and inspector name.",
            "Parameters Checked: Write what points were checked.",
            "Result: Choose *Pass* when acceptable, *Fail* when rework is required, *Conditional* when accepted with specific pending actions.",
            "Defects and Corrective Action: Write defect details and fix plan.",
            "Retest Date: Fill if another inspection is needed.",
            "Status: Choose *Under Review* after inspection submission, *Approved* after closure, *Rework* when correction cycle is ongoing.",
            "Remarks: Add final notes for future reference.",
            "Attachments: Upload photos, test records, and signed reports."
          ],
          mediaType: 'video', mediaSrc: exVid4
        },
        {
          id: 'ex-5', title: "Clearance", label: "Clearance",
          description: "Tracks statutory and technical clearances with authority, submission, target, and status controls.",
          detailDescription: "*Clearance* helps teams track approvals from external/internal authorities. It keeps submission dates, target dates, and approval status visible to reduce schedule risk.",
          flowTitle: "Field-by-Field Guide (Clearance)",
          flowSteps: [
            "Project: Select the project for which clearance is required.",
            "Clearance Type: Select exact authority process (environment, fire, utility, traffic, local body, etc.) as per the submitted application.",
            "Authority: Enter approving authority/department name.",
            "Submission Date and Target Date: Enter both dates. Target date cannot be before submission date.",
            "Status (dropdown): *Draft* before filing, *Submitted* after filing, *Under Review* while authority checks, *Approved*/*Rejected* after decision, *Expired* when validity ends.",
            "Remarks: Record follow-up comments, blockers, or decision notes.",
            "Attachments: Upload application copies, acknowledgement proofs, and approval/rejection letters."
          ],
          mediaType: 'video', mediaSrc: exVid5
        }
      ]
    },
    scope: {
      icon: <Icons.Scope />, label: "Agreement & Scope",
      sections: [
        {
          id: 'as-1', title: "Project Scope", label: "Project Scope",
          description: "*Project Scope* first shows all project cards. When you click one card, it opens a detailed scope dashboard for that project.",
          detailDescription: "*Project Scope* works in two screens. Screen 1 is the *All Projects* card view for quick comparison. Screen 2 opens when you click a project card and shows full scope details, timeline, compliance, technical specifications, progress bars, and *Download PDF* for that selected project.",
          flowTitle: "Field-by-Field Guide (Project Scope)",
          flowSteps: [
            "All Projects View: This is the first screen. It shows project cards with project name, code, status, agreement value, end date, and financial progress.",
            "Project Filter (dropdown): Use *All Projects* for full list, or choose one project to focus quickly.",
            "Project Card Click: Click any project card to open the detailed *Project Scope* screen for that project.",
            "Back to Overview: In detailed screen, use *Back to Overview* to return to the *All Projects* card list.",
            "All Projects Button: In detailed screen, use *All Projects* to go back from one project view to complete project list.",
            "Header Details: Detailed screen shows selected project name, scope text, and agreement value on top.",
            "Timeline & Contractual Block: Check LOA date, commencement date, target end date, and total construction days allowed.",
            "Progress Bars: Review Financial Progress and Project Elapsed Time bars to understand current status.",
            "Schedule Status: Read *On Schedule* / *Near Deadline* / *Overdue* indicator for quick timeline risk check.",
            "Compliance Status Block: Check Environment and Fire NOC status directly from this panel.",
            "Technical Specifications Block: Review built-up area, plot area, floors, and basements shown for selected project.",
            "Download PDF Button: Use *Download PDF* in the detailed screen to export the selected project scope view.",
            "Scope Attachments: View or download linked scope/agreement files when available."
          ],
          mediaType: 'image', mediaSrc: asImg1,
          gallery: [
            { id: 'as-1-g1', subtitle: "Project Scope - All Projects View", text: "This view shows project cards with agreement value, end date, and financial progress. Click any card to open that project’s detailed *Project Scope* screen.", type: 'image', src: asImg1 },
            { id: 'as-1-g2', subtitle: "Project Scope - Detailed View", text: "This view opens after clicking a project card. It shows scope description, timeline and contractual details, compliance status, technical specifications, progress bars, and *Download PDF* for the selected project.", type: 'image', src: asImg2 }
          ]
        },
        {
          id: 'as-2', title: "Project Hand Over", label: "Project Hand Over",
          description: "Tracks handover items, dates, recipients, and status for scope-to-execution transfer control.",
          detailDescription: "*Project Hand Over* records handover deliverables and completion state. It ensures accountability for who handed over what, when, and in what status.",
          flowTitle: "Field-by-Field Guide (Project Hand Over)",
          flowSteps: [
            "Project: Select the project where handover is being recorded.",
            "Category: Choose *Land* for land/ROW documents, *Drawings* for technical handover, *Reports* for report sets, *Approvals* for permissions, *Equipment* for physical asset transfer.",
            "Item Description: Enter what is handed over.",
            "Handover Date: Enter transfer date.",
            "Received By: Record receiving person/team for accountability.",
            "Status (dropdown): *Pending* before start, *In Progress* during transfer, *Completed* after closure, *On Hold* when blocked.",
            "Status in Register: You can update status directly from table dropdown as work progresses.",
            "Attachments and Remarks: Upload signed records/support files and add context notes."
          ],
          mediaType: 'video', mediaSrc: asVid1
        },
        {
          id: 'as-3', title: "Site Office", label: "Site Office",
          description: "Maintains project-linked site office records including location, setup, and operational details.",
          detailDescription: "*Site Office* stores operational office information used for project coordination and administration at site level.",
          flowTitle: "Field-by-Field Guide (Site Office)",
          flowSteps: [
            "Project: Select project under which the site office is maintained.",
            "Office Name and Address: Enter office name and full address.",
            "Contact Details: Enter contact person, phone, and email.",
            "Setup Date: Enter office setup date.",
            "Status: Choose *Active* when office is currently used; choose *Inactive* when office is closed/not in use.",
            "Facilities: Add facilities list (example: AC, CCTV, DG Set).",
            "Phone Validation: Phone accepts 10 digits only.",
            "Updates: Use *Edit* / *Delete* to keep office master data current."
          ],
          mediaType: 'video', mediaSrc: asVid2
        },
        {
          id: 'as-4', title: "Client Office", label: "Client Office",
          description: "Maintains client office records for project coordination, communication, and official visits.",
          detailDescription: "*Client Office* captures office-wise stakeholder details to support smooth communication and document routing.",
          flowTitle: "Field-by-Field Guide (Client Office)",
          flowSteps: [
            "Project: Select project linked to the client office entry.",
            "Office Name and Address: Enter client office name and full address.",
            "Department: Add client-side department/unit name where applicable.",
            "Contact Details: Enter contact person, phone, and email.",
            "Visiting Hours: Enter visit time (example: Mon-Fri 10AM-5PM).",
            "Appointment Required: Toggle *Appointment Required* when prior appointment is mandatory.",
            "Key Officials: Add important officials in readable format (e.g., SE: Name, EE: Name).",
            "Phone Validation: Phone accepts 10 digits only.",
            "Maintenance: Keep records updated with *Edit* / *Delete* to match latest client office structure."
          ],
          mediaType: 'video', mediaSrc: asVid3
        }
      ]
    },
    admin: {
      icon: <Icons.Admin />, label: "Admin Panel",
      sections: [
        {
          id: 'ad-1', title: "Projects List", label: "Projects List",
          description: "Create and maintain project master data, agreement identifiers, dates, scope values, and attachments used across the application.",
          detailDescription: "*Projects List* is the central place to register each project with letter of award details, contractual dates, location, and detailed scope. Accurate project records drive filters, registers, and reports everywhere else.",
          flowTitle: "Field-by-Field Guide (Projects List)",
          flowSteps: [
            "Project Name: Enter the official project title as used in agreements and correspondence.",
            "Agreement Prefix / Code: Use the consistent project code shown on letters and registers.",
            "Letter of Award: Fill letter number and date from the LOA or work order.",
            "Status: Use *Active* while the project is live; update when closed or on hold.",
            "Start / End Dates: Enter contractual commencement and stipulated completion dates.",
            "Target Mandays & DLP: Fill manpower targets and defect liability / maintenance windows when applicable.",
            "Location & Type: Record site location, project type, and contract type for reporting context.",
            "Scope Block: Enter work description, agreement and revised values, percentages, built-up and plot data, floors, NOC / clearance flags, and key structures.",
            "Attachments: Upload scope PDFs and supporting agreement documents.",
            "Maintenance: Use *Edit* to refresh dates and values; keep scope attachments current after amendments."
          ],
          mediaType: 'video', mediaSrc: adVid1,
          details: [
            { id: 'ad-1-d1', subtitle: "Why it matters", text: "Every module filters by project; keeping this master accurate avoids wrong postings and report gaps." }
          ]
        },
        {
          id: 'ad-2', title: "Users & Roles", label: "Users & Roles",
          description: "Provision logins, assign roles (SITE, HO, PM, ADMIN), and maintain contact details for secure access control.",
          detailDescription: "*Users & Roles* lets administrators add people to the system, set their role, and update credentials. Roles control which areas of the dashboard each user can open.",
          flowTitle: "Field-by-Field Guide (Users & Roles)",
          flowSteps: [
            "Full Name: Enter the person’s name as it should appear in the system.",
            "Email: Use a unique login email; it must not duplicate another user.",
            "Mobile: Optional contact number for coordination (10 digits when provided).",
            "Role: Choose *SITE* for site execution, *HO* for head-office oversight, *PM* for project management, or *ADMIN* for full administrative access.",
            "Password (new user): Set an initial password; user can be asked to reset later if your process requires it.",
            "Edit User: Use *Edit User* to update name, email, mobile, or role; use optional password reset only when a new password is intended.",
            "Delete User: *Delete User* removes the user and their project assignments—confirm before deleting."
          ],
          mediaType: 'video', mediaSrc: adVid2,
          details: [
            { id: 'ad-2-d1', subtitle: "Access control", text: "Assign the minimum role needed for the job to reduce accidental changes to master or financial data." }
          ]
        },
        {
          id: 'ad-3', title: "Consultants", label: "Consultants",
          description: "Maintain consultant master records with discipline, company, and contact details for drawings and coordination.",
          detailDescription: "*Consultants* stores third-party design and supervision firms. These records are used when linking consultants to projects and in assignment workflows.",
          flowTitle: "Field-by-Field Guide (Consultants)",
          flowSteps: [
            "Consultant Name: Enter the firm or individual name as used in contracts and letters.",
            "Discipline: Pick the primary discipline (e.g. *Architect*, *Structural*, *MEP*, *QS*, *Other*).",
            "Company: Add organization name when the consultant works under a company banner.",
            "Email / Mobile: Optional; mobile must be 10 digits if entered.",
            "Add Consultant: Click *Add Consultant* and save after validation; the record appears in lists and assignment pickers.",
            "Delete Consultant: *Delete Consultant* removes the consultant and related project assignments after confirmation."
          ],
          mediaType: 'video', mediaSrc: adVid3,
          details: [
            { id: 'ad-3-d1', subtitle: "Data quality", text: "Consistent names and disciplines make assignment lists and filters easier to use." }
          ]
        },
        {
          id: 'ad-4', title: "Project Assignments", label: "Project Assignments",
          description: "Link employees and consultants to projects, including per-project roles for staff and optional site credential creation.",
          detailDescription: "*Project Assignments* connects users and consultants to the correct projects. Employee assignments can carry a project-level role; consultant assignments tie external partners to projects for access and reporting.",
          flowTitle: "Field-by-Field Guide (Project Assignments)",
          flowSteps: [
            "Employees vs Consultants: Use the *Employees* tab for internal users and the *Consultants* tab for external consultants.",
            "Pick User or Consultant: Select the person or firm to attach.",
            "Pick Project: Choose the project they should see in their workspace.",
            "Employee Role: Set the assignment role (e.g. viewer vs project role options available in the form) where applicable.",
            "Site Credentials (if offered): Optionally create site login details when onboarding a site-only user through this flow.",
            "Add Assignment: Click *Add Assignment* and confirm to save; the user or consultant then receives access scoped to that project.",
            "Remove: Click *Remove* on a row when someone moves off a project—access updates immediately after removal."
          ],
          mediaType: 'video', mediaSrc: adVid4,
          details: [
            { id: 'ad-4-d1', subtitle: "Security tip", text: "Review assignments when staff rotate; remove old project links to avoid unintended data visibility." }
          ]
        }
      ]
    }
  }), [
    ovImg1, ovImg2, repImg1, repImg2, repImg3, repImg4, repImg5, repImg6, repImg7,
    corrVid1, corrVid2, corrVid3AppendEntry,
    corrImg31CorrespondenceReport, corrImg32ThreadReportPreview,
    finVid1, finVid2, finVid3,
    exVid1, exVid2, exVid3, exVid4, exVid5,
    asImg1, asImg2, asVid1, asVid2, asVid3,
    adVid1, adVid2, adVid3, adVid4
  ]);

  const handleMainTabChange = (key) => setActiveTab(key);

  const guideSearchNormalized = useMemo(() => normalizeGuideSearchText(guideSearchQuery), [guideSearchQuery]);
  const guideSearchLower = guideSearchNormalized;

  const activeSections = useMemo(() => {
    if (selectedDetail) {
      return selectedDetail.gallery || (selectedDetail.details || []).map((d, i) => ({ ...d, id: d.id || `det-${i}`, type: selectedDetail.mediaType, src: selectedDetail.mediaSrc }));
    }
    const sections = GUIDE_DATA[activeTab].sections;
    if (!guideSearchNormalized) return sections;
    return sections.filter((s) => sectionMatchesGuideSearch(s, guideSearchNormalized));
  }, [selectedDetail, GUIDE_DATA, activeTab, guideSearchNormalized]);
  const detailHeroMap = {
    'co-1b': 'co-1b-g1',
    'fi-1': 'fi-1-g1'
  };
  const detailHeroId = selectedDetail ? detailHeroMap[selectedDetail.id] : null;

  return (
    <div className="v-doc-page">
      <ScrollSpyNav sections={activeSections} />
      {expanded && ( <div className="v-doc-modal-overlay" onClick={closeExpanded}><div className="v-doc-modal-content" onClick={e => e.stopPropagation()}><VisualMedia mediaType={expanded.type} mediaSrc={expanded.src} isModal={true} onClose={closeExpanded} initialTime={expanded.time} isRowVisible={true} /></div></div> )}

      {!selectedDetail ? (
        <>
          <div className="v-doc-hero">
            <div className="v-doc-hero-topbar">
              <div className="v-doc-search-wrap v-doc-search-wrap--hero">
                <span id="guide-search-static-desc" className="v-doc-visually-hidden">
                  Filters topics in the selected module tab. Matches titles and descriptions even with small spelling mistakes, and understands related words and abbreviations such as RA, BG, or EOT.
                </span>
                <label className="v-doc-search-label" htmlFor="guide-topic-search">Search topics</label>
                <div className="v-doc-search-field">
                  <span className="v-doc-search-icon" aria-hidden><Icons.Search /></span>
                  <input
                    id="guide-topic-search"
                    type="search"
                    className="v-doc-search-input"
                    placeholder="Typos & related words OK…"
                    value={guideSearchQuery}
                    onChange={(e) => setGuideSearchQuery(e.target.value)}
                    autoComplete="off"
                    spellCheck="false"
                    aria-describedby="guide-search-static-desc"
                  />
                  {guideSearchLower ? (
                    <span className="v-doc-search-count" role="status" aria-live="polite">
                      {activeSections.length} {activeSections.length === 1 ? 'topic' : 'topics'}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="v-doc-hero-main">
              <div className="v-doc-hero-badge"><div className="v-doc-hero-badge-dot"></div>INSTRUCTIONAL GUIDES</div>
              <h1 className="v-doc-hero-title">Visual Documentation</h1>
              <p className="v-doc-hero-subtitle">High-fidelity smooth video walkthroughs with immersive motion.</p>
              <p className="v-doc-hero-hint">
                {parseUiHighlights('On each topic card, choose *View More Details* to open the full guide: longer explanation, step-by-step field notes, and image or video gallery where available. Use *Back* to return to this overview.')}
              </p>
            </div>
          </div>
          <div className="v-doc-nav">
            <div className="v-doc-tabs">
              {Object.entries(GUIDE_DATA).map(([key, data]) => (
                <button key={key} onClick={() => handleMainTabChange(key)} className={`v-doc-tab ${activeTab === key ? 'active' : ''}`}><span className="v-doc-tab-icon">{data.icon}</span><span className="v-doc-tab-label">{data.label}</span></button>
              ))}
            </div>
          </div>
          <div className="v-doc-content">
            <div className="v-doc-sections animate-fade-in">
              {activeSections.length === 0 ? (
                <div className="v-doc-search-empty" role="status">
                  <p>No topics match your search in <strong>{GUIDE_DATA[activeTab].label}</strong>.</p>
                  <p className="v-doc-search-empty-tip">Try different words, clear the filter, or switch module tab.</p>
                  <button type="button" className="v-doc-search-clear-btn" onClick={() => setGuideSearchQuery('')}>Clear search</button>
                </div>
              ) : (
                activeSections.map((section, index) => (
                  <SectionRow key={section.id} section={section} index={index} handleExpand={handleExpand} onDetail={setSelectedDetail} />
                ))
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="v-doc-detail-view-container animate-fade-in" style={{ backgroundColor: '#fcfcfd', margin: '-40px -56px -80px -16px', padding: '0 0 100px 0' }}>
          <div className="v-doc-sticky-nav">
            <div className="v-doc-nav-inner">
              <button className="v-doc-breadcrumb-btn" onClick={() => setSelectedDetail(null)}> <Icons.ArrowLeft /><span className="v-breadcrumb-root">Back</span> </button>
              <div className="v-doc-breadcrumb-separator"><Icons.ChevronRight /></div>
              <button className="v-doc-breadcrumb-btn" onClick={() => setSelectedDetail(null)}> <span className="v-breadcrumb-parent">{GUIDE_DATA[activeTab].label}</span> </button>
              <div className="v-doc-breadcrumb-separator"><Icons.ChevronRight /></div>
              <div className="v-doc-breadcrumb-current"> <span>{selectedDetail.title}</span> </div>
            </div>
          </div>
          <div className="v-doc-detail-header-v2">
            <div className="v-doc-header-content">
              <div className="v-doc-category-tag">{GUIDE_DATA[activeTab].label.toUpperCase()} MODULE</div>
              <h1 className="v-doc-header-title">{selectedDetail.title}</h1>
              <p className="v-doc-header-desc">{parseUiHighlights(selectedDetail.detailDescription || selectedDetail.description)}</p>
            </div>
            <div className="v-doc-header-accent-line"></div>
          </div>
          {selectedDetail.gallery?.length > 0 ? (
            <div className="animate-fade-in">
              {detailHeroId ? (
                <>
                  <div className="v-doc-sections" style={{ padding: '0 40px', marginTop: '24px' }}>
                    {(selectedDetail.gallery || [])
                      .filter((item) => item.id === detailHeroId)
                      .map((item) => (
                        <SectionRow key={item.id} section={item} index={0} handleExpand={handleExpand} isDetailRow={true} />
                      ))}
                  </div>
                  {selectedDetail.flowSteps?.length > 0 && (
                    <div className="v-doc-guided-split-wrap v-doc-guided-split-wrap--after-append-hero animate-fade-in">
                      <div className="v-doc-guided-stack">
                        <div className="v-doc-guided-steps">
                          <StepFlowGuide title={selectedDetail.flowTitle} steps={selectedDetail.flowSteps} />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="v-doc-sections" style={{ padding: '0 40px', marginTop: '24px' }}>
                    {(selectedDetail.gallery || [])
                      .filter((item) => item.id !== detailHeroId)
                      .map((item, index) => (
                        <SectionRow key={item.id || `gal-rest-${index}`} section={item} index={index + 1} handleExpand={handleExpand} isDetailRow={true} />
                      ))}
                  </div>
                </>
              ) : (
                <>
                  <div className="v-doc-sections" style={{ padding: '0 40px', marginTop: '24px' }}>
                    {(selectedDetail.gallery || []).map((item, index) => (
                      <SectionRow key={item.id || `gal-${index}`} section={item} index={index} handleExpand={handleExpand} isDetailRow={true} />
                    ))}
                  </div>
                  {selectedDetail.flowSteps?.length > 0 && (
                    <div className="v-doc-guided-split-wrap animate-fade-in">
                      <div className="v-doc-guided-stack">
                        <div className="v-doc-guided-steps">
                          <StepFlowGuide title={selectedDetail.flowTitle} steps={selectedDetail.flowSteps} />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          ) : selectedDetail.flowSteps?.length > 0 ? (
            <div className="v-doc-guided-split-wrap animate-fade-in">
              <div className="v-doc-guided-stack">
                <div className="v-doc-guided-video">
                  <VisualMedia mediaType={selectedDetail.mediaType} mediaSrc={selectedDetail.mediaSrc} mediaSlides={selectedDetail.mediaSlides || selectedDetail.gallery?.map((g) => g.src).filter(Boolean)} onExpand={handleExpand} isRowVisible={true} />
                </div>
                <div className="v-doc-guided-steps">
                  <StepFlowGuide title={selectedDetail.flowTitle} steps={selectedDetail.flowSteps} />
                </div>
              </div>
            </div>
          ) : (
            <div className="v-doc-sections animate-fade-in" style={{ padding: '0 40px', marginTop: '40px' }}>
              {activeSections.map((item, index) => (
                <SectionRow key={item.id} section={item} index={index} handleExpand={handleExpand} isDetailRow={true} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserGuide;
